import { createContext, useContext, type ReactNode } from "react";
import { useLocation } from "wouter";

interface ViewingLeadContextType {
  /**
   * Historically opened a small modal with the lead-capture form. Real
   * slot-picking needs full-page space, so this now tracks which button
   * was clicked (kept for funnel reporting) and navigates straight to the
   * full booking page instead.
   */
  openModal: (buttonContext: string) => void;
}

const ViewingLeadContext = createContext<ViewingLeadContextType | null>(null);

function trackButtonClick(buttonContext: string) {
  if (typeof window !== "undefined" && typeof window.fbq === "function") {
    window.fbq("trackCustom", "ViewingCTAClick", { buttonContext });
  }
}

export function ViewingLeadProvider({ children }: { children: ReactNode }) {
  const [, navigate] = useLocation();

  const openModal = (buttonContext: string) => {
    trackButtonClick(buttonContext);
    navigate("/book-viewing");
  };

  return <ViewingLeadContext.Provider value={{ openModal }}>{children}</ViewingLeadContext.Provider>;
}

export function useViewingLead() {
  const context = useContext(ViewingLeadContext);
  if (!context) {
    throw new Error("useViewingLead must be used within ViewingLeadProvider");
  }
  return context;
}
